<template>
  <div class="row">
    <div class="col-md-12 pad-to-5">
      <p></p>
      <kds-section-form :route="route" @on-submit="onUserSubmit"></kds-section-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import KdsSectionForm from './KdsSectionForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      KdsSectionForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        userLabel: {},
        modelValidations: {
          name: {
            required: true,
            min: 15
          },
          color: {
            required: true
          }
        }
      }
    },
    methods: {
      onUserSubmit (model, isValid) {
        this.userLabel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/Kds/Sections/KdsSectionEdit.vue